exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inconsolata&display=swap);", ""]);

// module
exports.push([module.id, ".code .ant-form-item {\n  margin-bottom: 0;\n}\n.code .ant-form-item label {\n  color: #f7931e;\n}\n.code__redeem-code .ant-form-item-control-wrapper {\n  font-family: 'Inconsolata', monospace;\n  font-size: 16px;\n  font-weight: bold;\n}\n.code__form-item--important .ant-form-item-control-wrapper {\n  font-weight: bold;\n  font-size: 16px;\n}\n.code__type-tag {\n  font-size: 16px;\n  padding: 4px 16px 4px 16px;\n  font-weight: 500;\n}\n", ""]);

// exports
